import { defineStore } from 'pinia';
import { useDbStore } from './dbStore';

export const useERezeptStore = defineStore('eRezept', {
  state: () => ({
    defaultDates: getDefaultDates(),
    activeTab: 'PZN-Verordnung',
    formData: {
      institution: '',
      ausstellendePerson: '',
      abzeichnendePerson: '',
      aktenzeichen: '',
      ausstellungsdatum: new Date().toISOString().split('T')[0],
      ersatzverordnung: '00',
      unfallart: '',
      unfalltag: '',
      unfallbetrieb: '',
      anzahl: 1,
      medikament: '',
      dosierung: null,
      abgabehinweise: null,
      mehrfachverordnung: false,
      mehrfachverordnungAnzahl: null,
      mehrfachverordnungNenner: '',
      mehrfachverordnungStart: '',
      mehrfachverordnungEnde: '',
    },
    muster15formData: {
      diagnosisICD: null,
      diagnosisText: null,
      folgeversorgung: false,
      bvg: false,
      accidentType: null,
      note: null,
      ohren: {
        rechts: createOhrData(),
        links: createOhrData()
      },
      weberTestErgebnisLinks: false
    },
    muster12FormData: {
      erstverordnung: false,
      folgeverordnung: false,
      unfall: false,
      ser: false,
      periodStart: getDefaultDates().start,
      periodEnd: getDefaultDates().end,
      medicationInput: '',
      medicationPreparation: false,
      medicationPreparationFrequency: [{ frequency: 1, from: '', to: '' }],
      medicationAdministration: false,
      medicationAdministrationFrequency: [{ frequency: 1, from: '', to: '' }],
      injection: false,
      injectionPreparation: false,
      injectionIntramuscular: false,
      injectionSubcutaneous: false,
      injectionFrequency: [{ frequency: 1, from: '', to: '' }],
      bloodSugarInitial: false,
      bloodSugarIntensive: false,
      bloodSugarFrequency: [{ frequency: 1, from: '', to: '' }],
      compressionStockingsPutOn: false,
      compressionStockingsTakeOff: false,
      compressionStockingsFrequency: [{ frequency: 1, from: '', to: '' }],
      compressionBandageApply: false,
      compressionBandageRemove: false,
      compressionBandageFrequency: [{ frequency: 1, from: '', to: '' }],
      supportiveBandages: false,
      supportiveBandagesType: '',
      supportiveBandagesFrequency: [{ frequency: 1, from: '', to: '' }],
      compressionRight: false,
      compressionLeft: false,
      compressionBoth: false,
      woundType: '',
      woundLocation: '',
      woundSize: '',
      woundGrade: '',
      woundMaterials: '',
      woundAcute: false,
      woundAcuteFrequency: [{ frequency: 1, from: '', to: '' }],
      woundChronic: false,
      woundChronicFrequency: [{ frequency: 1, from: '', to: '' }],
      otherMeasures1: '',
      otherMeasures1Frequency: [{ frequency: 1, from: '', to: '' }],
      otherMeasures2: '',
      otherMeasures2Frequency: [{ frequency: 1, from: '', to: '' }],
      patientInstruction: '',
      patientInstructionCount: null,
      patientInstructionFrequency: [{ frequency: 1, from: '', to: '' }],
      basicCare: false,
      preventiveCare: false,
      basicCareDetails: false,
      basicCareFrequency: [{ frequency: 1, from: '', to: '' }],
      householdCare: false,
      householdCareFrequency: [{ frequency: 1, from: '', to: '' }],
      additionalNotes: ''
    },
   serviceRequests: {
        medicationServiceRequest: null,
        bloodSugarServiceRequest: null,
        compressionServiceRequest: null,
        woundCareServiceRequest: null,
        otherMeasuresServiceRequest: null,
        basicCareServiceRequest: null,
      },
  }),
  actions: {
    setServiceRequest(type, serviceRequest) {
      this.serviceRequests[type] = serviceRequest;
    },

    resetServiceRequests() {
      this.serviceRequests = {
        medicationServiceRequest: null,
        bloodSugarServiceRequest: null,
        compressionServiceRequest: null,
        woundCareServiceRequest: null,
        otherMeasuresServiceRequest: null,
        basicCareServiceRequest: null,
      };
    },
    
    setActiveTab(tab) {
      this.activeTab = tab;
      this.formData.medikament = '';
      const dbStore = useDbStore();
      dbStore.setSelectedMedicationPZN(null);
    },
    updateFormField(field, value) {
      this.formData[field] = value;
    },
    updateMuster15OhrField(side, category, field, value) {
      if (field) {
        this.muster15formData.ohren[side][category][field] = value;
      } else {
        this.muster15formData.ohren[side][category] = value;
      }
    },

    getAudiogramPoints(side) {
      const frequencies = ['0125KHz', '025KHz', '05KHz', '1KHz', '15KHz', '2KHz', '3KHz', '4KHz', '6KHz', '8KHz', '10KHz'];
      return frequencies.map((freq, index) => ({
        x: index,
        y: this.muster15formData.ohren[side].hoerverlust[freq] ? parseInt(this.muster15formData.ohren[side].hoerverlust[freq]) : null
      })).filter(point => point.y !== null);
    },

    updateAudiogramPoint(side, xIndex, yValue) {
      const frequencies = ['0125KHz', '025KHz', '05KHz', '1KHz', '15KHz', '2KHz', '3KHz', '4KHz', '6KHz', '8KHz', '10KHz'];
      const freq = frequencies[xIndex];
      if (freq) {
        this.muster15formData.ohren[side].hoerverlust[freq] = yValue.toString();
      }
    },

    getVerstaendlichkeitPoints(side) {
      return this.muster15formData.ohren[side].verstaendlichkeit.map((point, index) => ({
        x: index,
        y: point
      })).filter(point => point.y !== null);
    },
    
    updateVerstaendlichkeitPoint(side, xIndex, yValue) {
      const verstaendlichkeitValues = ['0', '20', '40', '60', '80', '100'];
      const verstaendlichkeit = verstaendlichkeitValues[xIndex];
      if (verstaendlichkeit) {
        this.muster15formData.ohren[side].verstaendlichkeit[xIndex] = yValue;
      }
    },

    resetForm() {
      Object.keys(this.formData).forEach(key => {
        if (key === 'ausstellungsdatum') {
          this.formData[key] = new Date().toISOString().split('T')[0];
        } else if (key === 'ersatzverordnung') {
          this.formData[key] = '00';
        } else if (key === 'anzahl') {
          this.formData[key] = 1;
        } else if (typeof this.formData[key] === 'boolean') {
          this.formData[key] = false;
        } else if (typeof this.formData[key] === 'number') {
          this.formData[key] = null;
        } else {
          this.formData[key] = '';
        }
      });
    },
    async createERezept() {
      const dbStore = useDbStore();
      try {
        return await dbStore.createERezeptBundle(this.activeTab, this.formData);
      } catch (error) {
        console.error('Error creating E-Rezept:', error);
        throw error;
      }
    },
    updateMuster12FormData(field, value) {
      this.muster12FormData[field] = value;
    },
  },
});

function createOhrData() {
  return {
    hoerverlust: {
      '10KHz': '', '8KHz': '', '6KHz': '', '4KHz': '', '3KHz': '',
      '2KHz': '', '15KHz': '', '1KHz': '', '05KHz': '', '025KHz': '', '0125KHz': ''
    },
    verstaendlichkeit: [null, null, null, null, null, null],
    stapediusreflex: {
      SL: { '05KHz': '', '1KHz': '', '2KHz': '', '4KHz': '' },
      HL: { '05KHz': '', '1KHz': '', '2KHz': '', '4KHz': '' }
    },
    diskriminationsverlust: '',
    gehoergang: { erweitert: false, eng: false },
    trommelfell: { durchloechert: false, feucht: false },
    hoerhilfeNotwendig: false,
    hoorweite: { FlSpr: '', UmSpr: '' },
    moDruckH2O: '',
    testgeraeuschLautstaerke: '',
    tinnitushilfe: {
      frequenz: '',
      verdeckbarLautstaerke: '',
      notwendig: false
    },
    weberTestErgebnis: false,
  };
}

function getDefaultDates() {
  const today = new Date();
  const nextWeek = new Date(today);
  nextWeek.setDate(today.getDate() + 7);

  return {
    start: today.toISOString().split('T')[0],
    end: nextWeek.toISOString().split('T')[0]
  };
}
